import React from "react";
import { useLocalization } from "../../providers/LocalizationProvider";
import { Button } from "./Button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./Dialog";

export default function Confirm({ open, title, description, confirmLabel, cancelLabel, onConfirm, onCancel, extra }) {
  const { t } = useLocalization();
  
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="sm:max-w-[425px] max-w-[95vw]">
        <DialogHeader>
          <DialogTitle className="text-base sm:text-lg">{title}</DialogTitle>
          {description && <DialogDescription className="text-sm">{description}</DialogDescription>}
        </DialogHeader>
        {extra}
        <DialogFooter className="pt-2 sm:pt-4">
          <Button variant="outline" onClick={onCancel} className="w-full sm:w-auto">
            {cancelLabel || t('common.cancel')}
          </Button>
          <Button variant="destructive" onClick={onConfirm} className="w-full sm:w-auto">
            {confirmLabel || t('common.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}